import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 16,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.6237 0.327327C6.81322 0.118853 7.08189 0 7.36364 0H19.1818C19.9172 0 20.6297 0.280807 21.1609 0.792076C21.6934 1.3046 22 2.00805 22 2.75V13.25C22 13.9919 21.6934 14.6954 21.1609 15.2079C20.6297 15.7192 19.9172 16 19.1818 16H7.36364C7.08189 16 6.81322 15.8811 6.6237 15.6727L0.26006 8.67267C-0.0866866 8.29125 -0.0866866 7.70875 0.26006 7.32733L6.6237 0.327327ZM7.80601 2L2.35146 8L7.80601 14H19.1818C19.4109 14 19.6232 13.9121 19.774 13.7669C19.9235 13.6231 20 13.4363 20 13.25V2.75C20 2.56369 19.9235 2.37691 19.774 2.23305C19.6232 2.08794 19.4109 2 19.1818 2H7.80601ZM10.2795 4.68153C10.6625 4.28362 11.2956 4.27152 11.6935 4.65451L13.7273 6.61205L15.7611 4.65451C16.159 4.27152 16.792 4.28362 17.175 4.68153C17.558 5.07945 17.5459 5.71249 17.148 6.09549L15.1693 8L17.148 9.90451C17.5459 10.2875 17.558 10.9206 17.175 11.3185C16.792 11.7164 16.159 11.7285 15.7611 11.3455L13.7273 9.38795L11.6935 11.3455C11.2956 11.7285 10.6625 11.7164 10.2795 11.3185C9.89652 10.9206 9.90862 10.2875 10.3065 9.90451L12.2852 8L10.3065 6.09549C9.90862 5.71249 9.89652 5.07945 10.2795 4.68153Z",
		fill: "currentColor"
	})
});
export default SvgClear;
